import React, { useCallback, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ReactComponent as ApercuIcon } from "@/assets/icons/apercu.svg";
import { ReactComponent as IntegrationsIcon } from "@/assets/icons/integrations.svg";
import { ReactComponent as TieOutLogo } from "@/assets/icons/tie-out.svg";
import { ReactComponent as LogoutIcon } from "@/assets/icons/logout.svg";
import { logoutSession } from "@/api/auth";
import "./Sidebar.scss";

export const Sidebar: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = useCallback(async () => {
    if (isLoggingOut) {
      return;
    }
    setIsLoggingOut(true);
    try {
      await logoutSession();
    } finally {
      localStorage.removeItem("token");
      navigate("/login", { replace: true });
    }
  }, [isLoggingOut, navigate]);

  return (
    <aside className="sidebar" aria-label="Navigation principale">
      <button
        type="button"
        className="sidebar-logo"
        onClick={() => navigate("/dashboard")}
        aria-label={t("sidebar.overview")}
      >
        <TieOutLogo aria-hidden focusable="false" />
      </button>

      <nav className="sidebar-nav">
        <span className="sidebar-nav-section-label">
          {t("sidebar.workspace")}
        </span>
        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            `sidebar-nav-link ${isActive ? "sidebar-nav-link--active" : ""}`
          }
          end
        >
          <ApercuIcon aria-hidden focusable="false" />
          <span>{t("sidebar.overview")}</span>
        </NavLink>

        <span className="sidebar-nav-section-label">{t("sidebar.tools")}</span>
        <NavLink
          to="/integrations"
          className={({ isActive }) =>
            `sidebar-nav-link ${isActive ? "sidebar-nav-link--active" : ""}`
          }
        >
          <IntegrationsIcon aria-hidden focusable="false" />
          <span>{t("sidebar.integrations")}</span>
        </NavLink>

        <div className="sidebar-footer">
          <button
            type="button"
            className="sidebar-logout"
            onClick={() => void handleLogout()}
            disabled={isLoggingOut}
            aria-label={t("sidebar.logoutAria")}
          >
            <LogoutIcon
              className="sidebar-logout-icon"
              aria-hidden
              focusable="false"
            />
            <span className="sidebar-logout-label">{t("sidebar.logout")}</span>
          </button>
        </div>
      </nav>
    </aside>
  );
};
